'use client'

import { useEffect, useMemo } from 'react'
import {
    MapSelectInputResponseToOptionsProps,
    SelectListItem,
    mapSelectInputResponseToOptions,
} from './selectInputHelpers'
import { SelectOption } from '../../../types'

interface props {
    selectListResponse: {
        data: SelectListItem[]
        isLoading: boolean
        error: unknown
    }
    handleError?: (error: unknown) => void
    /** Optional custom mapping options */
    mapperOptions?: Pick<MapSelectInputResponseToOptionsProps<unknown>, 'formatName' | 'formatFooter'>
}

export const useCommonSelectListItems = ({ handleError, selectListResponse, mapperOptions }: props) => {
    useEffect(() => {
        if (selectListResponse.error && handleError) handleError(selectListResponse.error)
    }, [selectListResponse.error])

    const options = useMemo(() => {
        const freshData = selectListResponse?.data

        if (!freshData) return

        let newOptions = []

        if (mapperOptions) {
            newOptions = mapSelectInputResponseToOptions({
                selectItems: freshData,
                ...mapperOptions,
            })
        } else {
            newOptions = freshData.map<SelectOption>((option) => ({
                value: option.value ?? null,
                label: option.name ?? option.value ? String(option.value) : '',
            }))
        }

        return newOptions
    }, [selectListResponse])

    return {
        error: selectListResponse.error,
        isLoading: selectListResponse.isLoading,
        response: selectListResponse,
        options,
    }
}

export default useCommonSelectListItems
